import React, { useState } from 'react';
import data from './data.json';

const CountryStateDropdown = () => {
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [states, setStates] = useState([]);

  const handleCountrySelect = (event) => {
    const country = event.target.value;
    setSelectedCountry(country);

    // Get the states for the selected country
    const selectedCountryData = data.countries.find(
      (c) => c.name === country
    );
    if (selectedCountryData) {
      setStates(selectedCountryData.states);
      setSelectedState('');
    }
  };

  const handleStateSelect = (event) => {
    const state = event.target.value;
    setSelectedState(state);
  };

  return (
    <div>
      <h3>Dropdown</h3>
      <label htmlFor="country">Select a Country:</label>
      <select className='project-btn' id="country" value={selectedCountry} onChange={handleCountrySelect}>
        <option value="">Select</option>
        {data.countries.map((country) => (
          <option key={country.id} value={country.name}>
            {country.name}
          </option>
        ))}
      </select>

      {selectedCountry && (
        <div>
          <label htmlFor="state">Select a State:</label>
          <select className='project-btn' id="state" value={selectedState} onChange={handleStateSelect}>
            <option value="">Select</option>
            {states.map((state) => (
              <option key={state.id} value={state.name}>
                {state.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default CountryStateDropdown;
